import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../homepage/components/Footer';
import SEO from '../../components/SEO';
import IndustriesHero from './components/IndustriesHero';
import IndustriesGrid from './components/IndustriesGrid';
import WhyIndustryExpertise from './components/WhyIndustryExpertise';

const Industries = () => {
  const keywords = [
    'IT networking orthodontics',
    'dental practice IT support',
    'HIPAA compliant IT solutions',
    'banking cybersecurity services',
    'healthcare IT infrastructure',
    'education network security',
    'retail IT solutions',
    'professional services IT',
    'small business IT support',
    'PCI-DSS compliance',
    'network infrastructure',
    'cybersecurity solutions',
    'IT solutions by industry',
    'industry specific IT services'
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Industries We Serve - IT Networking & Cybersecurity"
        description="Specialized IT networking and cybersecurity solutions for orthodontics, dental practices, banking, healthcare, education, retail, and professional services. HIPAA and PCI-DSS compliant."
        keywords={keywords}
        canonical="/industries"
      />
      <Header />
      
      {/* Main Content */}
      <main className="pt-16 lg:pt-18">
        <IndustriesHero />
        <IndustriesGrid />
        <WhyIndustryExpertise />
      </main>
      
      <Footer />
    </div>
  );
};

export default Industries;
